import { useState } from 'react'
import { generatePath, useNavigate } from 'react-router'

import OrderItemPreviewList from '@entities/Order/ui/OrderItemPreviewList/OrderItemPreviewList'
import OrderOnlineItem from '@entities/Order/ui/OrderOnlineItem/OrderOnlineItem'

import { URL_PAGE_PRODUCT } from '@shared/contants'
import { OrdersEdge } from '@shared/generated'
import Wrapper from '@shared/ui/wrapper'

import OrderFooter from './OrderFooter'
import OrderHeader from './OrderHeader'
import OrderSummary from './OrderSummary'

import styles from './styles.module.scss'



interface OrderOnlineProps {
  data: NonNullable<NonNullable<OrdersEdge['edges']>[number]>;
  isInitialOpen?: boolean;
  onOrderUpdated?: () => Promise<unknown>;
}

export default function OrderOnline ({
  data,
  isInitialOpen,
  onOrderUpdated,
}: OrderOnlineProps) {
  const navigate = useNavigate()

  const [ isDetail, setIsDetail ] = useState(isInitialOpen ?? false)

  const handleDetailClick = () => {
    setIsDetail((p) => !p)
  }

  const handleProductClick = (productSlug?: string) => {
    if (!productSlug) return
    const link = generatePath(URL_PAGE_PRODUCT, { slug: productSlug })
    navigate(link)
  }

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <OrderHeader
          data={data}
          isDetail={isDetail}
          handleDetailClick={handleDetailClick}
          onOrderUpdated={onOrderUpdated}
        />
        <div className={styles.root__items}>
          {isDetail ? (
            data.meta?.map((el, i) => (
              <OrderOnlineItem key={`${el?.id}-${i}`} data={el} onNavToProduct={handleProductClick} />
            ))
          ) : (
            <OrderItemPreviewList items={data.meta} />
          )}
        </div>
        {isDetail && <OrderSummary data={data} />}
        {data?.receipts && data?.receipts.length > 0 ? (
          <OrderFooter data={data} />
        ) : null}
      </Wrapper>
    </div>
  )
}
